const AnalyticsTab = () => {
    return (
        <div>
            No Data
        </div>
    )
}

export default AnalyticsTab
